import { render, staticRenderFns } from "./RulesSection.vue?vue&type=template&id=05fbe6de&"
import script from "./RulesSection.vue?vue&type=script&lang=js&"
export * from "./RulesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports